module.exports = __webpack_public_path__ + "img/lg_ring_0_0_null_1@3x.c6c11798.png";